import api from "./api";

export const createDispatchCenter = async (payload) => {
    const res = await api.post("/dispatchcenter", payload);
    return res.data;
};

export const getDispatchCenters = async () => {
    const res = await api.get("/dispatchcenter");
    return res.data;
};

export const getDispatchCenterById = async (id) => {
    const res = await api.get(`/dispatchcenter/${id}`);
    return res.data;
};

export const assignDispatch = async (dispatchCenterId, payload) => {
    const res = await api.post(`/dispatchcenter/${dispatchCenterId}/assign`, payload);
    return res.data;
};

export const getDispatchAssignments = async (dispatchCenterId) => {
    const res = await api.get(`/dispatchcenter/${dispatchCenterId}/assignments`);
    return res.data;
};

export const completeDispatchAssignment = async (assignmentId) => {
    const res = await api.put(`/dispatchcenter/assignment/${assignmentId}/complete`);
    return res.data;
};

export default {
    createDispatchCenter,
    getDispatchCenters,
    getDispatchCenterById,
    assignDispatch,
    getDispatchAssignments,
    completeDispatchAssignment,
};